/* global fetch */

import adLoader from './adLoader'
import buildNestedRaces from './utils/buildNestedRaces'
import nestRaces from './utils/nestRaces'
import SelectCache from './utils/SelectCache'
// import scrollWatcher from './utils/scrollWatcher'
import Tock from 'tocktimer'
import { select } from './utils/selectors'
import * as Utils from './utils/utils'

import raceTpl from './templates/race.html'

const config = window.EMBED_CONFIG
const countdownDuration = 30 * 1000 // 30 seconds
const cache = new SelectCache()

const el = select('#race-results')
const timerEl = select('#timer')
const timerUpdatingEl = select('#timer-updating')
const countdownEl = select('#countdown')

const timer = new Tock({
  countdown: true,
  interval: 1000,
  callback: onTick,
  complete: onComplete
})

function toggleTimerUpdate () {
  timerEl.classList.toggle('hidden')
  timerUpdatingEl.classList.toggle('hidden')
}

function onTick () {
  countdownEl.textContent = `:${Utils.zeroPaddingFormatter(Math.ceil(timer.lap() / 1000))}`
}

function onComplete () {
  toggleTimerUpdate()
  update()
}

fetch(`${config.url}?_=${+new Date()}`)
  .then((resp) => resp.json())
  .then(nestRaces)
  .then(buildNestedRaces)
  .then((payload) => {
    el.innerHTML = payload
    adLoader()
    // timer.start(countdownDuration)
  }).catch((err) => console.error(err))

function update () {
  fetch(`${config.url}?_=${+new Date()}`)
    .then((resp) => resp.json())
    .then((races) => {
      if ('results' in races) races = races.results

      races.forEach((race) => {
        const selector = cache.get(`#${race.tt_race_slug}`)
        if (selector) {
          race.votes = Utils.getRaceVoteTotal(race.candidates)
          const tpl = raceTpl({ race, Utils, is_embed: config.is_embed })
          const div = document.createElement('div')
          div.innerHTML = tpl
          selector.innerHTML = select('.race', div).innerHTML
        }
      })

      window.setTimeout(() => {
        toggleTimerUpdate()
        timer.start(countdownDuration)
      }, 1500)
    })
}

// let originalTop = 0
// let fixed = false
//
// const controls = select('#timer-row')
// const controlsPlaceholder = select('#timer-row-placeholder')
//
// scrollWatcher.on('scroll', (data) => {
//   const controlsTop = controls.getBoundingClientRect().top
//
//   if (!originalTop) originalTop = controlsTop
//
//   if (!fixed) {
//     if (controlsTop <= 0) {
//       controls.classList.add('fixed')
//       controlsPlaceholder.classList.remove('hidden')
//       fixed = true
//     }
//   }
//
//   if (fixed && originalTop > data.offset) {
//     controls.classList.remove('fixed')
//     controlsPlaceholder.classList.add('hidden')
//     fixed = false
//   }
// })



/** WEBPACK FOOTER **
 ** ./scoreboard.js
 **/